import * as PmxApi from 'privmx-server-api';
import { EciesEncryptor } from './EciesEncryptor';
import * as privmx from 'privfs-client';
import { FormRowAdminData } from '../../types/Types';

export class InquirySubmitAdminDataEncryptor {
    async encrypt(
        pub: privmx.crypto.ecc.PublicKey | PmxApi.api.core.EccPubKey,
        data: FormRowAdminData
    ) {
        const pubKey =
            typeof pub === 'string' ? privmx.crypto.ecc.PublicKey.fromBase58DER(pub) : pub;
        return (await EciesEncryptor.encryptObjectToBase64(
            pubKey,
            data
        )) as PmxApi.api.inquiry.InquirySubmitAdminData;
    }

    async decrypt(
        priv: privmx.crypto.ecc.PrivateKey | PmxApi.api.core.EccWif,
        data: PmxApi.api.inquiry.InquirySubmitAdminData
    ) {
        const privKey =
            typeof priv === 'string' ? privmx.crypto.ecc.PrivateKey.fromWIF(priv) : priv;
        return (await EciesEncryptor.decryptObjectFromBase64(privKey, data)) as FormRowAdminData;
    }
}
